"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApListUnordered = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApListUnordered = function (_a) {
    var className = _a.className, children = _a.children, columnCount = _a.columnCount;
    return (React.createElement(styles_1.StyledListUnordered, { columnCount: columnCount, className: "ap-list-unordered " + (className ? className : '') }, children));
};
exports.ApListUnordered.defaultProps = {
    columnCount: 1
};
//# sourceMappingURL=ApListUnordered.js.map